import styled from 'styled-components'

export const Container = styled.div`
  .feedback-screen__content {
    max-width: 100%;
    padding: var(--spacing-24);
    width: 100%;
  }
  .feedback-screen {
    background-color: var(--neutral-theme);
  }
`
